uniform float uTime;
uniform float uIntensity;  // 0-1。GSAP でフェード
uniform float uMaxRadius;
uniform vec3 uColorInner;  // 中心の色（金）
uniform vec3 uColorOuter;  // 外縁の色（紫）

varying float vOffset;
varying float vRadius;

void main()
{
    // 柔らかい円形の粒
    float dist = length(gl_PointCoord - 0.5);
    float disc = 1.0 - smoothstep(0.1, 0.5, dist);

    // 個体位相の明滅
    float twinkle = 0.5 + 0.5 * (0.5 + 0.5 * sin(uTime * 2.0 + vOffset * 6.2831));

    // 中心は金、外縁へ行くほど紫
    vec3 color = mix(uColorInner, uColorOuter, clamp(vRadius / uMaxRadius, 0.0, 1.0));

    float strength = disc * twinkle * uIntensity;

    // 加算ブレンドなので色・アルファ両方に強度を掛ける
    gl_FragColor = vec4(color * strength, strength);
}
